import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SiteDataProvider } from './context/SiteDataContext';
import * as Sentry from "@sentry/react";
import {TonConnectUIProvider} from "@tonconnect/ui-react";
import clarity from "@microsoft/clarity";

clarity.init("rkj9fobdvb");

Sentry.init({
  dsn: "https://4f63b698bccc49309e55b73a6c683b3c@o4508671755878400.ingest.de.sentry.io/4508671770034256",
  integrations: [],
});

import './styles/index.css';
import Home from './pages/Home.tsx';
import TasksPage from './pages/TasksPage.tsx';
import SwapPage from './pages/SwapPage.tsx';
import NotFound from './pages/NotFound.tsx';
import About from './pages/About.tsx';


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TonConnectUIProvider manifestUrl='https://bot.tonupordown.site/tonconnect-manifest.json'>
      <SiteDataProvider>
        <BrowserRouter>
          <Routes>
            <Route path={"/"} element={<Home/>}/>
            <Route path={"/tasks"} element={<TasksPage/>}/>
            <Route path={"/swap"} element={<SwapPage/>}/>
            <Route path={"/about"} element={<About/>}/>
            <Route path={"/*"} element={<NotFound/>}/>
          </Routes>
        </BrowserRouter>
      </SiteDataProvider>
    </TonConnectUIProvider>
  </StrictMode>
);
